import React from 'react'
import PropTypes from 'prop-types'
import EmailVerifyAction from 'components/Actions/EmailVerify'

const EmailVerifyPage = ({ match }) => (
  <EmailVerifyAction token={match.params.token} />
)

EmailVerifyPage.propTypes = {
  match: PropTypes.object.isRequired
}

export default EmailVerifyPage
